import React from "react";
import TextInput from "../../components/common/inputs/textInput";
import Loading from "../../components/common/loading";
import { Link } from "react-router-dom";

class OutletGroupSelector extends React.Component {
  constructor(props) {
    super(props);
    const initial = Array.isArray(props.initialSelection)
      ? props.initialSelection.map(id => String(id))
      : [];
    this.state = {
      selected: new Set(initial),
      search: "",
      saving: false,
    };
  }

  toggleSelection = groupId => {
    this.setState(prev => {
      const next = new Set(prev.selected);
      if (next.has(groupId)) {
        next.delete(groupId);
      } else {
        next.add(groupId);
      }
      return { selected: next };
    });
  };

  handleSave = async () => {
    if (this.state.saving) return;
    this.setState({ saving: true });
    try {
      await this.props.onSave(Array.from(this.state.selected));
      this.props.close();
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const { outlet, groups = [] } = this.props;
    const outletGroups = groups.filter(g => g.groupType === "outlets");
    const filtered = outletGroups.filter(group => {
      const haystack = `${group.name || ""} ${group.description || ""}`.toLowerCase();
      return haystack.includes(this.state.search.toLowerCase());
    });

    return (
      <div style={{ minWidth: "520px" }}>
        <div style={{ marginBottom: "16px" }}>
          <strong>{outlet.outletName || `Outlet ${outlet.pduLabeledOutletNum || ""}`}</strong>
          <div style={{ color: "#6b7280", fontSize: "0.9rem" }}>
            Outlet ID: {outlet.outlet_id}
          </div>
        </div>
        <TextInput
          label="Search outlet groups"
          value={this.state.search}
          callback={value => this.setState({ search: value })}
          placeholder="Filter by group name or description"
        />
        <div
          style={{
            maxHeight: "320px",
            overflowY: "auto",
            marginTop: "10px",
            border: "1px solid #d7dde4",
            borderRadius: "4px",
          }}
        >
          {filtered.length === 0 ? (
            <div
              style={{
                padding: "16px",
                color: "#6b7280",
                textAlign: "center",
              }}
            >
              No outlet groups found.{" "}
              <Link to="/devices/outlet-groups">Create one</Link>
            </div>
          ) : (
            filtered.map(group => (
              <label
                key={group.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "12px 16px",
                  borderBottom: "1px solid #f1f5f9",
                  cursor: "pointer",
                }}
              >
                <div style={{ flex: 1, marginRight: "12px" }}>
                  <div style={{ fontWeight: 600 }}>{group.name}</div>
                  {group.description && (
                    <div style={{ color: "#6b7280", fontSize: "0.9rem" }}>
                      {group.description}
                    </div>
                  )}
                </div>
                <input
                  type="checkbox"
                  checked={this.state.selected.has(String(group.id))}
                  onChange={() => this.toggleSelection(String(group.id))}
                />
              </label>
            ))
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            paddingTop: "16px",
          }}
        >
          <button
            className="button secondary"
            onClick={() => this.props.close()}
            disabled={this.state.saving}
          >
            Cancel
          </button>
          <button
            className="button"
            onClick={this.handleSave}
            disabled={this.state.saving}
          >
            {this.state.saving ? <Loading /> : "Save"}
          </button>
        </div>
      </div>
    );
  }
}

export default OutletGroupSelector;
